import axios from 'axios';
import API from '../../../data/api';

/**
 * Mimesa's product categories (mimesa/service: `/products/categories`, sql/V4). Mary's API has
 * no such endpoints, so these calls live in Mimesa's folder.
 */
class MimesaCategoriesApi extends API {
    /** `[{ name, value, active, managed }]`: managed categories plus names products already use. */
    async requestCategories({ includeInactive = false } = {}) {
        const query = includeInactive ? '?includeInactive=true' : '';
        const response = await axios.get(`${this.apiUrl}/products/categories${query}`, await this.makeHeaders());
        if (response.status !== 200) throw new Error(response.data?.message || 'No se pudieron cargar las categorías');
        return Array.isArray(response.data?.categories) ? response.data.categories : [];
    }

    async requestCreateCategory(label) {
        const response = await axios.post(`${this.apiUrl}/products/categories`, { label }, await this.makeHeaders());
        if (response.status !== 201) throw new Error(response.data?.message || 'No se pudo crear la categoría');
        return response.data.category;
    }

    /** `patch`: `{ label?, active? }`. The category's name (key) never changes. */
    async requestUpdateCategory(name, patch) {
        const response = await axios.put(`${this.apiUrl}/products/categories/${encodeURIComponent(name)}`, patch, await this.makeHeaders());
        if (response.status !== 200) throw new Error(response.data?.message || 'No se pudo actualizar la categoría');
        return response.data.category;
    }
}

const categoriesApi = new MimesaCategoriesApi();
export default categoriesApi;
